export const GRAPHITE_API = {
  // fetch related article content -- for use on article pages
  relatedArticles:
    'https://api.graphitehq.com/il/curology/articles/related-links',
  // fetch random article content -- for use on non-article pages
  randomArticles:
    'https://api.graphitehq.com/il/curology/articles/random-links',
};
